import {

  Button,

  Grid,

  Typography,
} from '@mui/material'
import React, { useState } from 'react'

import TextAreaComponents from '../../components/TextAreaComponents/TextAreaComponents.tsx'

import InstructionTable from '../../components/SpecificationTable/InstructionTable.tsx'

import EditInstructionTable from '../../components/SpecificationTable/EditInstructionTable.tsx'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify'

function Instructions(props) {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [Rank, setRank]=useState()
  const[Id, setId]=useState()
  const [nameProps, setNameProps] = useState('')
  const [descriptionProps, setDescriptionProps] = useState('')
  const[NameErr, setNameErr]=useState(false)
  const[DescriptionErr, setDescriptionErr]=useState(false)
  const [DefaultInstructionData, setDefaultInstructionData]=useState()
  const [TempDefaultData, setTempDefaultData]=useState([])
  const[testState, setTestState]=useState(false)
  const [rows, setRows]=useState([])

console.log(props.defaultData)

  const handleName = (props) => {
    setName(props)
    setNameErr(false)

  }

  const handleDescription = (props) => {
    setDescription(props)
setDescriptionErr(false)

  }

  const getDataToEdit=(id,name,description,rank)=>{
    console.log(id)
    setId(id)
    setDescription(description)
    setName(name)
    setRank(rank)
  }
 

  React.useEffect(()=>{
    if(TempDefaultData!=undefined){
      
      setDefaultInstructionData(TempDefaultData)
    }
    
  },[testState])

  React.useEffect(()=>{
    setDefaultInstructionData(props.defaultData)
  },[props.defaultData])

  const apiAddress = process.env.REACT_APP_SECRET;

  const getTabledata=(tableData)=>{
    console.log(tableData)
    setRows(tableData)
    }

  const handleSave = () => {
    // <DetailsTable  />
    var valid=true;
    if((name=="" && description!="") || (name!="" && description==""))
    {
      valid=false
    }
    if(!!name==false){
      valid=false
      setNameErr(true)
    }
    if(!!description==false){
      setDescriptionErr(true)
    }
    if(valid && props.openFrom=='AddItem'){
      console.log('Instruction save from add')
      if(!!Id==false){
        setNameProps(name)
        setDescriptionProps(description)
        setName('')
        setDescription('')
      }
      }
      else if(valid && props.openFrom=='EditItem'){
        if(!!Id==false){
        setNameProps(name)
        setDescriptionProps(description)
        setName('')
        setDescription('')

        var detailsInsertObj={
          id: "123",
          foodItemId: props.FooditemId,
          name: name,
          description: description,
          rankOrder: 1,
          creationId: "string"
        }

        var url = apiAddress + "/api/FoodItems/InsertFoodItemInstructionFromEdit?alsoForLinked=false";

        axios.post(url, detailsInsertObj).then((response) => {
          console.log(response.data);
          //SetloadingModal(false);
          toast.success("Instruction Inserted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        console.log('Instruction save from edit')
        }
        else{
        console.log('Instruction update from Edit')
        console.log(props.FooditemId)
        var data=[...rows]
        console.log(data)
        var obj=data.find(x=>x.id==Id)
        console.log(obj)
        obj.name=name
        obj.description=description
        console.log(obj)

        var detailsUpdateObj={
          id: obj.id,
          foodItemId: props.FooditemId,
          name: obj.name,
          description: obj.description,
          rankOrder: obj.rankOrder,
          creationId: "string"
        }
        console.log(detailsUpdateObj)

        var url = apiAddress + "/api/FoodItems/FoodItemInstructionUpdate?InstructionId=" +obj.id;

        axios.put(url, detailsUpdateObj).then((response) => {
          console.log(response.data);
          //SetloadingModal(false);
          toast.success("Instruction Updated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setDefaultInstructionData([])
          setTempDefaultData(data)
          setTestState(!testState)
          setName('')
          setDescription('')
          setId('')
          setRank('')
        });
        }
      }
  }



  return (
    
    <div style={{ backgroundColor: '#f3f0f3' }}>
      {/* <ToastContainer /> */}
      <Grid container sx={{ padding: '0.5rem' }}>
        <Grid xs={2}>
          <Typography style={{ paddingTop: '1rem' }}>Name</Typography>
        </Grid>
        <Grid xs={10}>
          <TextAreaComponents label={'Item name'} value={handleName} val={name} />
          {NameErr && <span style={{color:'red'}}>This field is required</span>}
        </Grid>
      </Grid>
      <Grid container sx={{ padding: '0.5rem' }}>
        <Grid xs={2}>
          <Typography style={{ paddingTop: '1rem' }}>Description</Typography>
        </Grid>
        <Grid xs={10}>
          <TextAreaComponents id={1} label={'Description'} value={handleDescription} val={description}/>
          {DescriptionErr && <span style={{color:'red'}}>This field is required</span>}
        </Grid>
      </Grid>
      <Grid container sx={{ padding: '0.5rem' }}>
        <Grid item xs={11}></Grid>
        <Grid item xs={1}>
          <Button onClick={handleSave}>Save</Button>
        </Grid>
      </Grid>
      <Grid container sx={{ padding: '0.5rem' }}>
        <Grid item xs={2}></Grid>
        <Grid item xs={10}>
          {/* <InstructionTable Name={nameProps} Description={descriptionProps} sendInstructionToAdditem={props.sendInstructionToAdditem}/> */}
          {
             DefaultInstructionData? (
              <EditInstructionTable
               Id={Id} 
               Name={nameProps} 
               Description={descriptionProps} 
               Rank={Rank} 
               sendInstructionToAdditem={props.sendInstructionToAdditem}
               defaultData={DefaultInstructionData} 
               sendToInstruction={getTabledata}
               sendForEdit={getDataToEdit}/>
              ):(
                <InstructionTable Name={nameProps} Description={descriptionProps} sendInstructionToAdditem={props.sendInstructionToAdditem}/>
              )
          }
        </Grid>
      </Grid>


    </div>
  )
}

export default Instructions
